import React from "react";

interface ICardProps {
  selected?: boolean;
  title: string;
  color: string;
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  body: string;
}

const Card = (props: ICardProps) => (
  <div
    className={props.selected ? "card selected" : "card"}
    onClick={props.onClick}
  >
    <h3>{props.title}</h3>
    <div className={"triangle " + props.color}></div>
    <div dangerouslySetInnerHTML={{ __html: props.body }}></div>
  </div>
);

export default Card;
